export default "__VITE_ASSET__hmqYKpQJ__"